export default "__VITE_ASSET__CqkC06_N__"